import { session, setAuthHeader } from '@/api/session'

export default {
  getDictionary (name) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/dictionary/?dictionary=${name}`
    return session.get(url, setAuthHeader())
  },
  getBanks() {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/bank/`
    return session.get(url, setAuthHeader())
  },
  getPaymentCategories(limit, offset, paymentType) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/payment_category/?limit=${limit}&offset=${offset}&payment_type=${paymentType}`
    return session.get(url, setAuthHeader())
  },
  getSystemConstants (name) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/system_constant/?constants=${name}`
    return session.get(url, setAuthHeader())
  },
  getDashboardChart (scope, currency, chartType, paymentType, period, step) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/dashboard/?scope=${scope}&currency=${currency}&chart_type=${chartType}&payment_type=${paymentType}&period=${period}&step=${step ? step : 0}`
    return session.get(url, setAuthHeader())
  },
}
